import { Button, Result } from 'antd'

export const ResponseForm = ({ response, closeSuccess, close }) => {
    return (
        <div>
            {
                response.exist &&
                <div>
                    <Result
                        title='Usuario Encontrado'
                        subTitle='Se ha encontrado al usuario con la CURP ingresada'
                        status='success'
                        extra={[
                            <Button type="primary" key="console" onClick={closeSuccess}>
                                Continuar
                            </Button>,
                        ]}
                    />
                </div>
            }
            {
                response.success &&
                <div>
                    <Result
                        title='Registro Exitoso'
                        subTitle='Se ha completado correctamente su registro, ahora usted podrá votar por hasta 1 proyecto de su zona, 1 proyecto educativo y 1 proyecto general.'
                        status='success'
                        extra={[
                            <Button type="primary" key="console" onClick={closeSuccess}>
                                Continuar
                            </Button>,
                        ]}
                    />
                </div>
            }
            {
                response.error &&
                <div>
                    <Result
                        title='Error de Registro'
                        subTitle='Ha ocurrido un error al intentar registrar '
                        status='error'
                        extra={[
                            <Button type="primary" key="console" onClick={close}>
                                Aceptar
                            </Button>,
                        ]}
                    />
                </div>
            }
        </div>
    )
}
